export function sortBy(collection, key) {
  return collection.sort((a, b) => {
    if (a[key] < b[key]) return -1
    if (a[key] > b[key]) return 1
    return 0
  })
}

function _flattenTree(organizations, callback, result = [], parent = null) {
  organizations.forEach(organization => {
    if (callback) {
      callback(organization, parent)
    }
    result.push(organization)

    if (organization.children) {
      _flattenTree(organization.children, callback, result, organization)
    }
  })

  return result
}

export function flattenTree(organizations, callback) {
  return _flattenTree(organizations, callback)
}
